import { render, staticRenderFns } from "./ThirdScreen.vue?vue&type=template&id=2a0a00f6&scoped=true&"
import script from "./ThirdScreen.vue?vue&type=script&lang=js&"
export * from "./ThirdScreen.vue?vue&type=script&lang=js&"
import style0 from "./ThirdScreen.vue?vue&type=style&index=0&id=2a0a00f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a00f6",
  null
  
)

export default component.exports